import { useState, useEffect } from 'react';
import { lireJson } from '../utils/reponseHttp';

export const useAdminQuotaOverview = () => {
  const [overview, setOverview] = useState(null);
  const [policies, setPolicies] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAdminData = async () => {
    setLoading(true);
    try {
      const [overviewRes, policiesRes] = await Promise.all([
        fetch('/api/admin/usage/overview'),
        fetch('/api/admin/usage/policies')
      ]);

      // ⚠️ `res.ok` NE SUFFIT PAS, et c'est le cœur du défaut mesuré le
      //    2026-08-07. Sur un hôte qui sert l'interface sans router la surface
      //    API d'administration, nginx répond par le repli SPA : `index.html`
      //    en **200**. Le contrôle ci-dessous passait donc, et c'est
      //    `res.json()` qui cassait — l'utilisateur lisait à l'écran
      //    « Unexpected token '<', "<!DOCTYPE "... is not valid JSON », qui ne
      //    dit rien de la cause réelle.
      //    `lireJson` contrôle aussi le type de contenu et nomme la cause.
      const overviewData = await lireJson(overviewRes, '/api/admin/usage/overview');
      const policiesData = await lireJson(policiesRes, '/api/admin/usage/policies');

      setOverview(overviewData);
      setPolicies(policiesData);
      setError(null);
    } catch (err) {
      console.error('Erreur lors du chargement des données admin quota', err);
      setError(err.message || 'Impossible de charger la supervision quota.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminData();
    const interval = setInterval(fetchAdminData, 30000); // refresh 30s
    return () => clearInterval(interval);
  }, []);

  return { overview, policies, loading, error, refetch: fetchAdminData };
};
